var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLemonSliceRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0806 3.58834C11.693 1.5069 7.64573 1.33345 5.79556 1.5069C5.27519 1.79598 4.0957 2.47821 3.54065 2.8945C2.84684 3.41486 1.45923 6.01665 1.11232 7.23083C0.765418 8.445 1.28578 9.83262 1.80614 10.6999C2.3265 11.5672 4.75484 13.9955 5.79556 14.6893C6.83628 15.3831 9.13998 15.6859 10 15.4795C12 14.9995 13.4593 13.6873 14.5 12.4731C15.3326 11.5018 15.162 10.0061 15.162 8.79191C15.0464 7.92465 14.4682 5.66978 13.0806 3.58834Z",
    fill: "#FBE54D",
    stroke: "#351771"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57096 8.74076C8.29343 8.46323 5.4488 10.2441 4.40808 11.6896C5.10189 12.7303 7.00988 13.7709 7.70369 13.9444C8.3975 14.1179 8.91786 9.08766 8.57096 8.74076Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74417 8.74094C8.52645 8.41438 11.0384 11.0839 12.0396 12.5569C11.8381 13.5925 7.17429 14.078 7.8769 13.9446C8.05035 13.9117 9.09107 9.2613 8.74417 8.74094Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22455 8.3929C8.50123 8.67127 5.7964 9.78051 4.40873 11.6885C3.36786 10.8212 2.68871 8.62674 2.51737 7.9324C2.34604 7.23806 7.8787 8.04493 8.22455 8.3929Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74424 8.39474C8.41247 8.60443 11.0256 10.4009 11.953 12.5703C13.0063 12.63 14.2948 8.91518 13.601 8.91518C12.4903 8.91518 9.15895 8.13263 8.74424 8.39474Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22445 8.21999C7.89834 8.43838 6.0476 5.61986 5.30716 3.99994C5.67926 3.01274 7.68362 2.87844 8.3979 2.84292C9.11219 2.80741 8.63208 7.94699 8.22445 8.21999Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.75
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.492 8.15622C8.21505 8.43433 11.4011 6.1665 12.6692 4.91577C12.6725 3.86078 7.98767 2.61594 8.65103 2.88318C8.81479 2.94916 8.93329 7.71308 8.492 8.15622Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.75
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05056 8.22028C8.41285 8.37124 6.26635 6.02511 5.27532 3.88408C4.37707 4.65036 2.50023 5.79202 2.50023 7.69999C2.50023 7.8915 5.9692 7.35301 8.05056 8.22028Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.75
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74438 8.04719C9.51211 7.79736 11.5196 5.44537 12.7338 5.09851C13.7786 5.24436 14.4059 8.76509 13.6907 8.76509C12.7337 8.76508 8.27786 8.199 8.74438 8.04719Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.75
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09582 7.92879C9.09582 7.65127 8.05509 7.48644 8.05509 8.2757C7.98531 8.96959 8.78354 8.96959 8.92235 8.96959H8.92236C9.26919 8.96959 9.09582 8.2757 9.09582 7.92879Z",
    fill: "#351771",
    stroke: "#351771",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLemonSliceRound);
export default __webpack_public_path__ + "static/media/lemon-slice-round.e827329f16cd1c75160f6abc6a66b323.svg";
export { ForwardRef as ReactComponent };